import './App.css';

function App() {
  return (
    <div className='app'>
      Deneme
    </div>
  );
}

export default App;
